import { ComplianceDialog } from '../../components/ComplianceDialog';

import { useMissionQuotationComplianceIssues } from './hooks/useMissionQuotationComplianceIssues.hook';

export const MissionQuotationComplianceDialog = () => (
  <ComplianceDialog
    blockingTitle="Bloquant pour la soumission, la génération du devis ou sa synchronisation avec Pennylane"
    id="mission-quotation-compliance"
    issues={useMissionQuotationComplianceIssues()}
    title="Conformité du devis"
  />
);
